import type { FC } from "react";

// TODO(Jakub): use theme colours

export type LogoIconProps = {
  height?: number;
  scale?: number;
  size?: number;
  width?: number;
};

const ICON_VIEWBOX = 30;
export const AuremIcon: FC<LogoIconProps> = ({
  height,
  scale,
  size,
  width,
}) => {
  const scaledSize = size ?? ICON_VIEWBOX * (scale ?? 1);
  return (
    <div className="drop-shadow-md">
      <svg
        fill="none"
        height={height ?? scaledSize}
        viewBox={`0 0 ${ICON_VIEWBOX} ${ICON_VIEWBOX}`}
        width={width ?? scaledSize}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_230_12446)">
          <g clipPath="url(#clip1_230_12446)">
            <g clipPath="url(#clip2_230_12446)">
              <path
                d="M0 11.7068C0 7.56391 0 5.49624 0.819549 3.91729C1.51128 2.59023 2.59399 1.50752 3.92105 0.81579C5.49624 0 7.56391 0 11.7068 0H18.2932C22.4323 0 24.5038 0 26.0789 0.819549C27.406 1.51128 28.4887 2.59023 29.1805 3.92105C30 5.49624 30 7.56767 30 11.7068V18.2932C30 22.4323 30 24.5038 29.1805 26.0789C28.4925 27.406 27.406 28.4887 26.0789 29.1805C24.5038 30 22.4323 30 18.2932 30H11.7068C7.56767 30 5.49624 30 3.92105 29.1805C2.59399 28.4925 1.51128 27.406 0.819549 26.0789C0 24.5038 0 22.4323 0 18.2932L0 11.7068Z"
                fill="black"
              />
            </g>
            <g clipPath="url(#clip3_230_12446)">
              <path
                d="M25.4461 22.3529V24.3505H23.3619V22.3529H25.4461Z"
                fill="#F0FE53"
              />
              <path
                d="M10.6202 13.7089H8.58778L4.50708 24.3425H6.58525L7.4631 21.9542H11.6951L12.5789 24.3425H14.6989L10.6202 13.7089ZM8.08814 20.2577L9.57511 16.2168L11.07 20.2577H8.08814Z"
                fill="#F0FE53"
              />
              <path
                d="M22.1656 16.6873V24.3425H20.3104V23.1643C20.0556 23.567 19.7132 23.884 19.2872 24.1152C18.8593 24.3465 18.3855 24.4621 17.866 24.4621C17.3464 24.4621 16.8448 24.3504 16.4228 24.1232C16.0008 23.8979 15.6743 23.575 15.4434 23.1583C15.2125 22.7397 15.097 22.2552 15.097 21.705V16.6873H16.9383V21.2744C16.9383 21.7269 17.0717 22.0938 17.3424 22.3808C17.6131 22.6659 17.9695 22.8094 18.4114 22.8094C18.8135 22.8094 19.1578 22.6998 19.4425 22.4845C19.7271 22.2692 19.9441 21.9542 20.0914 21.5415C20.2387 21.1269 20.3124 20.6325 20.3124 20.0504V16.6873H22.1676H22.1656Z"
                fill="#F0FE53"
              />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_230_12446">
            <rect fill="white" height="30" rx="3.97483" width="30" />
          </clipPath>
          <clipPath id="clip1_230_12446">
            <rect fill="white" height="30" width="30" />
          </clipPath>
          <clipPath id="clip2_230_12446">
            <rect fill="white" height="30" width="30" />
          </clipPath>
          <clipPath id="clip3_230_12446">
            <rect
              fill="white"
              height="10.7512"
              transform="translate(4.50708 13.7089)"
              width="20.939"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export type AuremLogoProps = {
  height?: number;
  scale?: number;
  width?: number;
};

const LOGO_VIEWBOX_W = 47;
const LOGO_VIEWBOX_H = 20;
export const AuremLogo: FC<AuremLogoProps> = ({ height, scale = 5, width }) => {
  let sizeW = scale * LOGO_VIEWBOX_W;
  let sizeH = scale * LOGO_VIEWBOX_H;
  if (width && !height) {
    sizeW = width;
    sizeH = (sizeW / LOGO_VIEWBOX_W) * LOGO_VIEWBOX_H;
  } else if (!width && height) {
    sizeH = height;
    sizeW = (sizeH / LOGO_VIEWBOX_H) * LOGO_VIEWBOX_W;
  } else if (width && height) {
    sizeW = width;
    sizeH = height;
  }
  return (
    <svg
      fill="none"
      height={sizeH}
      viewBox={`0 0 ${LOGO_VIEWBOX_W} ${LOGO_VIEWBOX_H}`}
      width={sizeW}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect height={sizeH} rx="2" width={sizeW} />
      <path
        d="M7.31661 6.30411L8.51407 9.62637H6.12552L7.31661 6.30411ZM6.4408 4L3 13.1782H4.85171L5.5777 11.1542H9.0642L9.79366 13.1782H11.7078L8.25491 4H6.4408Z"
        fill="white"
      />
      <path
        d="M18.0139 13.1782H16.3623V12.1983C16.1454 12.529 15.8573 12.7921 15.4992 12.9875C15.1406 13.1829 14.7403 13.28 14.2983 13.28C13.8563 13.28 13.4306 13.1823 13.0719 12.9875C12.7133 12.7921 12.4339 12.5143 12.2337 12.1535C12.0335 11.7928 11.9335 11.3749 11.9335 10.8994V6.57131H13.5978V10.4921C13.5978 10.8741 13.7059 11.1836 13.9229 11.4214C14.1398 11.6592 14.4313 11.7781 14.7987 11.7781C15.1325 11.7781 15.4136 11.6868 15.6433 11.5044C15.8723 11.3219 16.0499 11.0589 16.1749 10.7152C16.2998 10.3715 16.3623 9.95773 16.3623 9.47396V6.57131H18.0139V13.1776V13.1782Z"
        fill="white"
      />
      <path
        d="M22.3929 8.04793C22.0759 8.04793 21.7861 8.1415 21.5235 8.32807C21.2609 8.51463 21.048 8.81184 20.8854 9.21911C20.7229 9.62637 20.6413 10.1402 20.6413 10.7593V13.1782H18.9897V6.5713H20.6413V7.76779C20.7911 7.39466 21.0543 7.08509 21.4298 6.83849C21.8052 6.59249 22.1928 6.46948 22.5931 6.46948C22.7765 6.46948 22.9142 6.47772 23.0061 6.49479V8.11149C22.806 8.06911 22.6018 8.04793 22.3929 8.04793Z"
        fill="white"
      />
      <path
        d="M29.5121 9.70287C29.5121 9.15966 29.3929 8.64234 29.1552 8.14974C28.9174 7.65772 28.5588 7.25458 28.0792 6.9403C27.5996 6.62661 27.0136 6.46947 26.3212 6.46947C25.6288 6.46947 25.0578 6.62897 24.5823 6.94677C24.1068 7.26517 23.7504 7.68538 23.5127 8.20741C23.2749 8.72885 23.1558 9.28266 23.1558 9.86825C23.1558 10.4538 23.2813 11.0077 23.5312 11.5297C23.7817 12.0511 24.1548 12.4737 24.6511 12.7962C25.1475 13.1187 25.7375 13.28 26.4213 13.28C26.972 13.28 27.462 13.1905 27.8918 13.0122C28.321 12.8345 28.6756 12.5731 28.955 12.2294C29.2344 11.8857 29.4074 11.4808 29.4745 11.0141H27.8351C27.7686 11.2772 27.6118 11.485 27.3659 11.638C27.1201 11.7904 26.8216 11.8669 26.4716 11.8669C25.9458 11.8669 25.531 11.6886 25.2267 11.3325C25.0005 11.0683 24.8588 10.7246 24.8004 10.3014H29.4866C29.5034 10.089 29.5121 9.88944 29.5121 9.70287ZM24.8467 9.05372C24.8744 8.92895 24.9091 8.81184 24.9514 8.70355C25.0723 8.39398 25.2493 8.15621 25.483 7.99083C25.7167 7.82545 25.9961 7.74247 26.3212 7.74247C26.6047 7.74247 26.8488 7.79956 27.0536 7.91432C27.2578 8.02909 27.4163 8.18623 27.5291 8.38515C27.6413 8.58466 27.7061 8.80772 27.7229 9.05372H24.8467Z"
        fill="white"
      />
      <path
        d="M30.25 6.57129H31.9015V7.56415C32.0936 7.22456 32.3475 6.95737 32.6645 6.76198C32.9815 6.56717 33.3483 6.46947 33.7654 6.46947C34.2825 6.46947 34.71 6.57365 35.0479 6.7814C35.3857 6.98915 35.6339 7.29695 35.7924 7.70422C35.9758 7.34757 36.2575 7.0533 36.637 6.81965C37.0164 6.58659 37.452 6.46947 37.9443 6.46947C38.4031 6.46947 38.8074 6.56305 39.158 6.74962C39.5085 6.93618 39.7793 7.19926 39.9713 7.53884C40.1634 7.87842 40.2588 8.2645 40.2588 8.69707V13.1776H38.5945V9.1679C38.5945 8.7777 38.4921 8.46813 38.2879 8.2386C38.0837 8.00967 37.802 7.8949 37.4434 7.8949C37.0095 7.8949 36.674 8.06911 36.4362 8.41693C36.1985 8.76475 36.0799 9.23146 36.0799 9.81705V13.1776H34.4283V9.1679C34.4283 8.7777 34.3259 8.46813 34.1217 8.2386C33.9175 8.00967 33.6358 7.8949 33.2772 7.8949C32.9937 7.8949 32.7473 7.97553 32.539 8.13679C32.3308 8.29805 32.1717 8.52287 32.0635 8.81125C31.9547 9.09963 31.9009 9.43921 31.9009 9.82941V13.177H30.2494V6.57129H30.25Z"
        fill="white"
      />
      <path
        d="M42.9497 11.4085H41.1477V13.1776H42.9497V11.4085Z"
        fill="white"
      />
    </svg>
  );
};
